import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientAddressEntity } from './client-address.entity';
import { InvoiceEntity } from './invoice.entity';
import { ItemEntity } from './item.entity';
import { OrderEntity } from './order.entity';

@Index(
	'client_address_item_hasAggregatedData__deleted_userId',
	['deletedUserId', 'hasAggregatedData'],
	{},
)
@Index('client_address_item_pk', ['fkClientAddressId', 'fkItemId'], {
	unique: true,
})
@Index('fk_client_address__id', ['fkClientAddressId'], {})
@Index('fk_invoice__id_last', ['fkInvoiceIdLast'], {})
@Index('fk_item__id', ['fkItemId'], {})
@Index('fk_order__id_last', ['fkOrderIdLast'], {})
@Entity('client_address_item')
export class ClientAddressItemEntity extends BaseEntity {
	@Column('decimal', {
		name: 'lastPrice',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public lastPrice!: string | null;

	@Column('int', { name: 'soldUnitsMtd', nullable: true })
	public soldUnitsMtd!: number | null;

	@Column('int', { name: 'soldUnitsLastMonth', nullable: true })
	public soldUnitsLastMonth!: number | null;

	@Column('int', { name: 'soldUnitsTwoMonthsAgo', nullable: true })
	public soldUnitsTwoMonthsAgo!: number | null;

	@Column('decimal', {
		name: 'revenueMtd',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public revenueMtd!: string | null;

	@Column('decimal', {
		name: 'revenueLastMonth',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public revenueLastMonth!: string | null;

	@Column('decimal', {
		name: 'revenueTwoMonthsAgo',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public revenueTwoMonthsAgo!: string | null;

	@Column('int', { name: 'dailyLimit', nullable: true })
	public dailyLimit!: number | null;

	@Column('decimal', {
		name: 'averageInvoiceRevenue',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public averageInvoiceRevenue!: string | null;

	@Column('decimal', {
		name: 'invoiceFrequency',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public invoiceFrequency!: string | null;

	@Column('decimal', {
		name: 'forecast',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public forecast!: string | null;

	@Column('decimal', {
		name: 'likelihood',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public likelihood!: string | null;

	@Column('decimal', {
		name: 'revenueTrend360',
		nullable: true,
		precision: 14,
		scale: 10,
	})
	public revenueTrend360!: string | null;

	@Column('decimal', {
		name: 'revenueTrendDiff360',
		nullable: true,
		precision: 14,
		scale: 10,
	})
	public revenueTrendDiff360!: string | null;

	@Column('decimal', {
		name: 'revenueTrend90',
		nullable: true,
		precision: 14,
		scale: 10,
	})
	public revenueTrend90!: string | null;

	@Column('decimal', {
		name: 'revenueTrendDiff90',
		nullable: true,
		precision: 14,
		scale: 10,
	})
	public revenueTrendDiff90!: string | null;

	@Column('decimal', {
		name: 'minimumTrendDiff',
		precision: 14,
		scale: 10,
		default: () => "'0.0000000000'",
	})
	public minimumTrendDiff!: string;

	@Column('decimal', {
		name: 'rollingTotalGPAggregate30',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingTotalGpAggregate30!: string | null;

	@Column('decimal', {
		name: 'rollingTotalGPAggregate90',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingTotalGpAggregate90!: string | null;

	@Column('decimal', {
		name: 'rollingTotalGPMargin30',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingTotalGpMargin30!: string | null;

	@Column('decimal', {
		name: 'rollingTotalGPMargin90',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingTotalGpMargin90!: string | null;

	@Column('decimal', {
		name: 'rollingRevenue30',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingRevenue30!: string | null;

	@Column('decimal', {
		name: 'rollingRevenue90',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingRevenue90!: string | null;

	@Column('decimal', {
		name: 'rollingTotalGPAggregateTrend30',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingTotalGpAggregateTrend30!: string | null;

	@Column('decimal', {
		name: 'rollingTotalGPAggregateTrend90',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingTotalGpAggregateTrend90!: string | null;

	@Column('decimal', {
		name: 'rollingTotalGPMarginTrend30',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingTotalGpMarginTrend30!: string | null;

	@Column('decimal', {
		name: 'rollingTotalGPMarginTrend90',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingTotalGpMarginTrend90!: string | null;

	@Column('decimal', {
		name: 'rollingRevenueTrend30',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingRevenueTrend30!: string | null;

	@Column('decimal', {
		name: 'rollingRevenueTrend90',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingRevenueTrend90!: string | null;

	@Column('decimal', {
		name: 'rollingQuantity30',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingQuantity30!: string | null;

	@Column('decimal', {
		name: 'rollingQuantity90',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public rollingQuantity90!: string | null;

	@Column('decimal', {
		name: 'averageInvoiceTotalGP',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public averageInvoiceTotalGp!: string | null;

	@Column('decimal', {
		name: 'averageInvoiceQuantity',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public averageInvoiceQuantity!: string | null;

	@Column('date', { name: 'forecastedReorderDate', nullable: true })
	public forecastedReorderDate!: string | null;

	@Column('int', { name: 'frequencyRank', nullable: true })
	public frequencyRank!: number | null;

	@Column('int', { name: 'revenueRank', nullable: true })
	public revenueRank!: number | null;

	@Column('int', { name: 'totalGPRank', nullable: true })
	public totalGpRank!: number | null;

	@Column('int', { name: 'quantityRank', nullable: true })
	public quantityRank!: number | null;

	@Column('int', { name: 'revenueReorderRank', nullable: true })
	public revenueReorderRank!: number | null;

	@Column('int', { name: 'totalGPReorderRank', nullable: true })
	public totalGpReorderRank!: number | null;

	@Column('decimal', {
		name: 'lastOrderedListPrice',
		nullable: true,
		precision: 15,
		scale: 6,
	})
	public lastOrderedListPrice!: string | null;

	@Column('tinyint', {
		name: 'hasAggregatedData',
		width: 1,
		default: () => "'0'",
	})
	public hasAggregatedData!: boolean;

	@Column('int', { name: 'fk_client_address__id', unsigned: true })
	public fkClientAddressId!: number;

	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('int', {
		name: 'fk_invoice__id_last',
		nullable: true,
		unsigned: true,
	})
	public fkInvoiceIdLast!: number | null;

	@Column('int', { name: 'fk_order__id_last', nullable: true, unsigned: true })
	public fkOrderIdLast!: number | null;

	@ManyToOne(
		() => ClientAddressEntity,
		(clientAddress) => clientAddress.clientAddressItems,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([{ name: 'fk_client_address__id', referencedColumnName: 'id' }])
	public fkClientAddress!: ClientAddressEntity;

	@ManyToOne(() => ItemEntity, (item) => item.clientAddressItems, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public fkItem!: ItemEntity;

	@ManyToOne(() => InvoiceEntity, (invoice) => invoice.clientAddressItems, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_invoice__id_last', referencedColumnName: 'id' }])
	public fkInvoiceIdLast2!: InvoiceEntity;

	@ManyToOne(() => OrderEntity, (order) => order.clientAddressItems, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_order__id_last', referencedColumnName: 'id' }])
	public fkOrderIdLast2!: OrderEntity;
}
